import React, { useState, Fragment } from 'react';

import ProcurementExpenseCustomPriceTable from './ProcurementExpenseCustomPriceTable';

import { formatAndRoundMoney, formatFigure, formatNegativeMoney } from 'Helpers/formatService';

export default function ProcurementExpensesDetailedRow({ uncommittedExpenditure, index, maxQuantities, varianceExists }) {
    const [show, setShow] = useState(false);

    const toggleDisplay = (hasCustomPrices) => {
        if (hasCustomPrices) {
            setShow(!show);
        }
    };

    const quantitiesNames = Array.from({ length: maxQuantities }, (_, i) => $t(`Quantity ${i + 1}`));
    const hasCustomPrices =
        (uncommittedExpenditure.detailed_amount.original_custom_prices && uncommittedExpenditure.detailed_amount.original_custom_prices.length > 0) ||
        (uncommittedExpenditure.detailed_amount.revised_custom_prices && uncommittedExpenditure.detailed_amount.revised_custom_prices.length > 0);

    if (!!uncommittedExpenditure.detailed_amount.type && uncommittedExpenditure.detailed_amount.type === 'project') {
        return null;
    }

    return (
        <Fragment key={index}>
            <tr className={`${hasCustomPrices ? 'cursor-pointer' : ''}`} onClick={() => toggleDisplay(hasCustomPrices)}>
                <td>
                    {uncommittedExpenditure.detailed_amount.department}
                    {uncommittedExpenditure.detailed_amount.costcenter && ` / ${uncommittedExpenditure.detailed_amount.costcenter}`}
                </td>
                <td>
                    {hasCustomPrices && (
                        <span className="ml-1 mr-2">{show ? <i className={'fa fa-chevron-up'} /> : <i className={'fa fa-chevron-down'} />}</span>
                    )}
                    {uncommittedExpenditure.detailed_amount.budget_line}
                </td>
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.detailed_amount.original_price, formatAndRoundMoney)}</td>
                {quantitiesNames.map((name, index) => {
                    const originalQuantity = uncommittedExpenditure.detailed_amount.original_quantity[index] || null;

                    return (
                        <td className="inbud-numeric-cell" key={`original-value-${index}`}>
                            {formatFigure(originalQuantity?.amount, (x) => x, { precision: 4 })}
                        </td>
                    );
                })}
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.detailed_amount.original_total, formatAndRoundMoney)}</td>
                {varianceExists && (
                    <>
                        <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.detailed_amount.revised_price, formatAndRoundMoney)}</td>
                        {quantitiesNames.map((name, index) => {
                            const revisedQuantity = uncommittedExpenditure.detailed_amount.revised_quantity[index] || null;

                            return (
                                <td className="inbud-numeric-cell" key={`revised-value-${index}`}>
                                    {formatFigure(revisedQuantity?.amount, (x) => x, { precision: 4 })}
                                </td>
                            );
                        })}
                        <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.detailed_amount.revised_total, formatAndRoundMoney)}</td>
                        <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.detailed_amount.variance, formatNegativeMoney)}</td>
                    </>
                )}
            </tr>
            {hasCustomPrices && show && (
                <>
                    <tr>
                        <td colSpan={varianceExists ? 7 + maxQuantities * 2 : 4 + maxQuantities}>
                            <ProcurementExpenseCustomPriceTable row={uncommittedExpenditure.detailed_amount} index={index} prefix={''} />
                        </td>
                    </tr>
                </>
            )}
        </Fragment>
    );
}
